namespace Solovis.Reports.TableFilters {
    export interface ValueTypeFilterControlOptions extends Solovis.UI.BaseControlOptions {
        initialState: Solovis.Reports.Parts.Tables.DataTableHelpers.FilterByValueTypesMatch[];

        onStateChanged?: () => void;
        height?: number;
    }

    const NodeIdForValueTypeNotSet = -9999999999;

    class TreeViewItem {
        id: number;
        label: string;

        valueTypeNotSetNode: TreeViewItem;

        selected: boolean = true;

        static createForValueType(id: number, label: string, valueTypesMatch: Solovis.Reports.Parts.Tables.DataTableHelpers.FilterByValueTypesMatch[]) {
            let node = new TreeViewItem();
            node.id = id;
            node.label = label;
            node.selected = !valueTypesMatch || valueTypesMatch.some(valueType => valueType.key === id && valueType.selected);

            return node;
        }
    }

    export class ValueTypeFilterControl extends Solovis.UI.BaseControl {
        public _initialState: Solovis.Reports.Parts.Tables.DataTableHelpers.FilterByValueTypesMatch[];

        public _treeViewContainer: JQuery;
        public _treeView: DevExpress.ui.dxTreeView;
        public _initialHeight: number;

        private _onStateChangedHandler: () => void;

        constructor(options: ValueTypeFilterControlOptions) {
            super(options);

            this._initialState = options.initialState;
            this._onStateChangedHandler = options.onStateChanged;
            this._initialHeight = options.height;
        }

        public doRender() {
            var self = this;

            this._treeViewContainer = $('<div>')
                .appendTo(this.container);

            let items = Solovis.Site.ValueTypes.getValueTypeOptions(0).map(
                item => TreeViewItem.createForValueType(item.value, item.text, this._initialState)
            );
            items.push(TreeViewItem.createForValueType(NodeIdForValueTypeNotSet, "(Not Set)", this._initialState))

            this._treeView = $(this._treeViewContainer).dxTreeView({
                items: items,
                dataStructure: 'tree',
                keyExpr: 'id',
                displayExpr: 'label',
                expandedExpr: 'expanded',
                showCheckBoxesMode: 'normal',
                onItemClick: function (e: any) {
                    if (e.itemData.selected) {
                        self._treeView.unselectItem(e.itemData);
                    } else {
                        self._treeView.selectItem(e.itemData);
                    }
                },
                onSelectionChanged: function () {
                    if (self._onStateChangedHandler) {
                        self._onStateChangedHandler();
                    }
                }
            }).dxTreeView('instance');

            if (this._initialHeight) {
                this.setHeight(this._initialHeight);
            }
        }

        public getCurrentState() {
            var currentState = this._treeView.getNodes() as Solovis.Reports.Parts.Tables.DataTableHelpers.FilterByValueTypesMatch[];
            return currentState;
        }

        public setHeight(newHeight) {
            if (this._treeViewContainer) {
                $(this._treeViewContainer).height(newHeight);
            }
            else {
                this._initialHeight = newHeight;
            }
        }


        public static showAsDialog(
            options: {
                valueTypeFilter: Solovis.Reports.Parts.Tables.DataTableHelpers.FilterByValueTypesMatch[];
                valueTypeId?: number;
            },
            newFilterCallback: (newFilter: Solovis.Reports.Parts.Tables.DataTableHelpers.FilterByValueTypesMatch[]) => any
        ) {
            var formDiv = $("<div>");

            var valueTypeFilterControl = new ValueTypeFilterControl({
                controlHost: formDiv,
                height: 100,
                initialState: options.valueTypeFilter
            });
            valueTypeFilterControl.setAsCurrentControl();

            var dialog = new Solovis.UI.Dialog({
                container: formDiv,

                width: 600,
                height: 500,
                center: true,
                modal: true,
                title: "Value Type Filter",

                noPaddingOnContent: true,

                buttons: [
                    {
                        label: "Clear",
                        click: () => {
                            newFilterCallback(null);
                            dialog.close();
                        }
                    },
                    {
                        label: "OK",
                        click: () => {
                            newFilterCallback(valueTypeFilterControl.getCurrentState());
                            dialog.close();
                        }
                    },
                    {
                        label: "Cancel",
                        click: () => {
                            dialog.close();
                        }
                    }
                ],

                contentHeightSizer: {
                    setHeight: function (newHeight) {
                        valueTypeFilterControl.setHeight(newHeight);
                    }
                }
            });
            dialog.open();
        }
    }
}
